import { escapeQuery } from './search';

export const getLabelValue = (
  labels: { key: string; value?: string | null }[],
  key: string,
) => {
  return labels.find(l => l.key === key)?.value ?? '';
};

export const replaceLabel = (
  labels: { key: string; value?: string | null }[],
  key: string,
  value: string,
) => {
  return [
    ...labels
      .filter(l => l.key !== key)
      .map(l => ({ key: l.key, value: l.value ?? '' })),
    { key, value },
  ];
};

export const csvIncludes = (csv: string, value: string) => {
  const target = value.trim();
  if (!target) return false;
  return csv
    .split(',')
    .map(s => s.trim())
    .filter(Boolean)
    .includes(target);
};

export const labelCsvHasValue = (
  labels: { key: string; value?: string | null }[],
  key: string,
  value: string,
) => {
  const csv = getLabelValue(labels, key);
  return csvIncludes(csv, value);
};

// Builds a precise CSV token filter for one or more values against a label key.
// It matches exact tokens in any position within the CSV: first, middle, last, or the only token.
export const buildCsvLabelExactTokenFilter = (
  values: string[],
  key: string,
) => {
  const field = `labels.${key}`;
  const parts = (values ?? [])
    .map(v => (v ?? '').trim())
    .filter(Boolean)
    .map(v => {
      const escaped = escapeQuery(v);
      const first = `${field}:"${escaped},*"`;
      const middle = `${field}:"*,${escaped},*"`;
      const last = `${field}:"*,${escaped}"`;
      const exact = `${field}:"${escaped}"`;
      return `(${first} OR ${middle} OR ${last} OR ${exact})`;
    });
  return parts.join(' OR ');
};

export const isDemoData = (
  labels?: { key: string; value?: string | null }[],
) => (labels ? getLabelValue(labels, 'demo_data') === 'true' : false);

export const strictlyFilteredList = <
  T extends { labels?: { key: string; value?: string | null }[] },
>(
  items: T[] | undefined,
  labelKey: string,
  values: string[],
) => {
  const trimmedValues = (values ?? [])
    .map(v => (v ?? '').trim())
    .filter(Boolean);
  if (!trimmedValues.length) return items;

  return (items ?? []).filter(item =>
    trimmedValues.some(v => labelCsvHasValue(item.labels ?? [], labelKey, v)),
  );
};
